import type { ComponentType } from 'react';
import { RatesPage } from './RatesPage';

/**
 * KUR EKRANLARI — menu kimligi -> bilesen.
 *
 * `src/app/screens.ts` bunlari tek satirla baglar; router'a DOKUNULMAZ
 * (bkz. o dosyanin bas yorumu).
 *
 * Iki bolge AYNI bileseni kullanir: tek fark, fiyat hucrelerinin musteride
 * talep acmasi ve buroda salt okunur olmasi — ve bu ayrim bilesenin ICINDE,
 * oturumdan turetiliyor. Iki ayri ekran dosyasi ayni duzenin iki kopyasi
 * demek olurdu.
 */
export const ratesScreens: Readonly<Record<string, ComponentType>> = Object.freeze({
  'customer.rates': RatesPage,
  'exchange.rates': RatesPage,
});
